import React, { useState, useEffect } from "react";
import ButtonComponent from "../../ButtonComponent";
import { COLORS } from "../../../lib/colors";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import MicIcon from "@mui/icons-material/Mic";
// import MoodIcon from "@mui/icons-material/Mood";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useUserState } from "../../../providers/UserProvider";
import DossierFab from "./DossierFab";
import PrescriptionFab from "./PrescriptionFab";
import VideoRecordingModal from "./VideoRecordingModal";
import CameraModal from "./CameraModal";
import VoiceRecordingModal from "./VoiceRecordingModal";
import FileUploadModal from "./FileUploadModal";
// import { useActiveRoomState } from "../../../providers/ActiveRoomProvider";
import classes from "./index.module.scss";

function Index({ sendMessage, addMessageToList, audienceId, visitToken }) {
  const user = useUserState();
  // const activeRoom = useActiveRoomState();

  const [userIsDocted, setUserIsDocted] = useState();
  const [inputValue, setInputValue] = useState("");
  const [showVideoeRecorder, setShowVideoeRecorder] = useState(false);
  const [showVoiceRecord, setShowVoiceRecord] = useState(false);
  const [camera, setCamera] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [attachType, setAttachType] = useState("dossier");

  useEffect(() => {
    if (user) {
      const userType = user.user_login.approve;
      if (userType === "doctor") {
        setUserIsDocted(true);
      }

      if (userType === "user") {
        setUserIsDocted(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const onChangeHandler = (e) => {
    if (e.keyCode === 13) {
      sendMessage(inputValue);
      setInputValue("");
    } else {
      setInputValue(e.target.value);
    }
  };

  const handleSend = () => {
    sendMessage(inputValue);
    setInputValue("");
  };

  return (
    <div className={classes.mainContainer}>
      <DossierFab
        handleVideoeRecorder={() => {
          setShowVideoeRecorder(true);
        }}
        handleCameraOpen={() => {
          setCamera(true);
        }}
        handleVoiceRecorder={() => {
          setShowVoiceRecord(true);
        }}
        handleFileUpload={() => {
          setShowFileUpload(true);
        }}
        setAttachType={() => {
          setAttachType("dossier");
        }}
      />
      {userIsDocted && (
        <PrescriptionFab
          handleVideoeRecorder={() => {
            setShowVideoeRecorder(true);
          }}
          handleCameraOpen={() => {
            setCamera(true);
          }}
          handleVoiceRecorder={() => {
            setShowVoiceRecord(true);
          }}
          handleFileUpload={() => {
            setShowFileUpload(true);
          }}
          setAttachType={() => {
            setAttachType("prescription");
          }}
        />
      )}

      <div className={classes.flexGrowitem}>
        <input
          className={classes.chatInput}
          type="text"
          name="name"
          onChange={onChangeHandler}
          onKeyDown={onChangeHandler}
          value={inputValue}
        />
      </div>
      {!inputValue && (
        <>
          <ButtonComponent
            backgroundColor={COLORS.purple}
            icon={<CameraAltIcon />}
            className={classes.actionBtns}
            onClick={() => {
              setCamera(true);
              setAttachType("dossier");
            }}
          ></ButtonComponent>
          <ButtonComponent
            backgroundColor={COLORS.purple}
            icon={<MicIcon />}
            className={classes.actionBtns}
            onClick={() => {
              setShowVoiceRecord(true);
              setAttachType("dossier");
            }}
          ></ButtonComponent>
        </>
      )}
      {inputValue && (
        <ButtonComponent
          backgroundColor={COLORS.purple}
          icon={<ArrowUpwardIcon />}
          className={classes.actionBtns}
          onClick={handleSend}
          style={{ marginLeft: 5 }}
        ></ButtonComponent>
      )}

      <CameraModal
        handleOpenCamera={camera}
        handleCloseCamera={() => {
          setCamera(false);
        }}
        visitToken={visitToken}
        audienceId={audienceId}
        addMessageToList={addMessageToList}
        attachType={attachType}
      />
      <FileUploadModal
        handleOpenFileUpload={showFileUpload}
        handleCloseFileUpload={() => {
          setShowFileUpload(false);
        }}
        visitToken={visitToken}
        audienceId={audienceId}
        addMessageToList={addMessageToList}
        attachType={attachType}
      />
      <VoiceRecordingModal
        handleOpenVoiceRecorder={showVoiceRecord}
        handleCloseVoiceRecorder={() => {
          setShowVoiceRecord(false);
        }}
        visitToken={visitToken}
        audienceId={audienceId}
        addMessageToList={addMessageToList}
        userId={user && user.user_login.client_id}
        attachType={attachType}
      />
      <VideoRecordingModal
        handleOpenVideoRecording={showVideoeRecorder}
        handleCloseVideoRecording={() => {
          setShowVideoeRecorder(false);
        }}
        visitToken={visitToken}
        audienceId={audienceId}
        addMessageToList={addMessageToList}
        attachType={attachType}
      />
    </div>
  );
}

export default Index;
